import { Box } from "@mui/material";
import { useContext, useState } from "react";

import { ChatContext } from "../../contexts/chat/context";
import { ChatHistoryDropdown } from "./chat_history_dropdown";
import { ChatHistoryModal } from "./chat_history_modal";
import { ChatHistoryItem } from "../../contexts/chat/type";

export const ChatStatus = ({ isConnected }: { isConnected: boolean }) => {
  const { chatContext, loadChatFromHistory } = useContext(ChatContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedHistoryItem, setSelectedHistoryItem] = useState<ChatHistoryItem | null>(null);

  // Only show as connected if both isConnected and chatContext are available
  const isActuallyConnected = isConnected && chatContext;

  const handleViewFullHistory = (item: ChatHistoryItem) => {
    setSelectedHistoryItem(item);
    setModalOpen(true);
  };

  const handleLoadToChat = (item: ChatHistoryItem) => {
    loadChatFromHistory(item);
    setModalOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              backgroundColor: isActuallyConnected
                ? "success.main"
                : "action.active",
              width: 8,
              height: 8,
              borderRadius: "50%",
              flexShrink: 0,
              animation: isActuallyConnected
                ? "pulse 2s ease-in-out infinite"
                : "none",
              "@keyframes pulse": {
                "0%": { opacity: 1 },
                "50%": { opacity: 0.5 },
                "100%": { opacity: 1 },
              },
            }}
          />
          <Box
            component="span"
            sx={{
              fontSize: "0.875rem",
              color: isActuallyConnected ? "text.primary" : "text.secondary",
            }}
          >
            {isActuallyConnected ? "Connected" : "Connecting..."}
          </Box>
        </Box>
        <ChatHistoryDropdown onViewFullHistory={handleViewFullHistory} />
      </Box>
      <ChatHistoryModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        historyItem={selectedHistoryItem}
        onLoadToChat={handleLoadToChat}
      />
    </>
  );
};
